module.exports = __webpack_public_path__ + "img/footer-kv.bedcc557.png";